import { render, staticRenderFns } from "./BrandCarSeriesModelsField.vue?vue&type=template&id=11bf9d1e&scoped=true"
import script from "./BrandCarSeriesModelsField.vue?vue&type=script&lang=ts"
export * from "./BrandCarSeriesModelsField.vue?vue&type=script&lang=ts"
import style0 from "./BrandCarSeriesModelsField.vue?vue&type=style&index=0&id=11bf9d1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf9d1e",
  null
  
)

export default component.exports